exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-wrapper[data-v-4c7c962b]{display:flex;align-items:flex-start;position:relative}.form-control[data-v-4c7c962b]{display:flex;align-items:center;min-height:calc(1.5em + .75rem + 2px);height:auto}.form-label[data-v-4c7c962b]{margin:0;font-size:14px;font-weight:700;user-select:none}.input-wrapper .form-label[data-v-4c7c962b]{opacity:1;background-color:#fff;padding-left:.5rem;line-height:1}", ""]);

// exports
